import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { IconChevronRight } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { BonificationBadge } from '../../billboard/all-listings/components/bonification-banner';

interface BonifiableListingsCountSuffixProps {
  bonifiableCount: number;
  count: number | undefined;
}

export function BonifiableListingsCountSuffix({ bonifiableCount, count }: BonifiableListingsCountSuffixProps) {
  return (
    <>
      {bonifiableCount > 0 ? <BonificationBadge /> : null}
      <Column
        justifyContent="center"
        width={40}
        marginLeft={bonifiableCount > 0 ? 'spacing.general.x4' : 'spacing.general.0'}
      >
        <Text color="text.tertiary" fontSize={16} fontWeight="400">
          {count ?? '-'}
        </Text>
      </Column>
      <Column>
        <IconChevronRight strokeWidth={ICON_STROKE_WIDTH} />
      </Column>
    </>
  );
}
